var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.47,413.16v-1.23a27.2,27.2,0,0,0-18.3-26.21,29.14,29.14,0,0,0-27.08,4.72c-4.42,3.52-8,8.46-13.42,10.12-7,2.17-14.17-1.95-20.28-5.9s-13.29-8.06-20.28-5.86c-4.38,1.38-7.73,5.07-9.9,9.14-5.75,10.78-4.1,24.51,2.35,34.73S154.67,449.89,166,454c15.91,5.7,34.15,6,49.58-1.26S243.06,430.17,244.47,413.16Z",
    style: {
      fill: "#91add321"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.71,44.26l-.06,1a23.48,23.48,0,0,0,11,21.65,22.58,22.58,0,0,0,3,1.52A24.67,24.67,0,0,0,253.8,66c3.94-2.73,7.27-6.7,11.91-7.8,6-1.45,11.87,2.44,16.81,6.12s10.79,7.55,16.82,6.08c3.77-.92,6.81-3.85,8.87-7.17,5.46-8.79,4.84-20.48,0-29.49s-13.49-15.5-22.87-19.57c-13.13-5.71-28.53-7-42-1.71S218.85,30,216.71,44.26Z",
    style: {
      fill: "#91add321"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.74,
    cy: 408.83,
    r: 20.36,
    transform: "translate(-355.1 402.05) rotate(-81.02)",
    style: {
      fill: "#91add321"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 440.65,
    cy: 411.08,
    r: 16.29,
    transform: "translate(-74.87 723.18) rotate(-74.2)",
    style: {
      fill: "#91add321"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 54.53,
    r: 18.67,
    style: {
      fill: "#91add321"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.94,462.61c0,.14-95.77.26-213.88.26s-213.9-.12-213.9-.26,95.75-.26,213.9-.26S456.94,462.47,456.94,462.61Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.81,
    y: 84.99,
    width: 412.54,
    height: 287.47,
    rx: 12.83,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.35,97.82l-.06-.9a7.64,7.64,0,0,0-.13-1.1,10.1,10.1,0,0,0-.34-1.51,12.76,12.76,0,0,0-6.41-7.82A13.2,13.2,0,0,0,439,85.3a19.45,19.45,0,0,0-4-.24h-9.29l-23.17,0-147.65.09-102,0H51.23a20.34,20.34,0,0,0-3.76.2,12.09,12.09,0,0,0-3.55,1.19,12.65,12.65,0,0,0-5.32,5.18,13.58,13.58,0,0,0-1.28,3.55,19.33,19.33,0,0,0-.24,3.82v23.53q0,15.83,0,32v66c0,44.85,0,91.28,0,138.84a12.53,12.53,0,0,0,10.21,12.35,22.59,22.59,0,0,0,4.37.22H168.34l129.34,0,117,0h20.35a21.22,21.22,0,0,0,3.3-.15A12.54,12.54,0,0,0,449,361.38a21.33,21.33,0,0,0,.13-3.21c0-1.08,0-2.15,0-3.23v-6.41q0-25.51,0-48.93c0-62.33.07-112.78.09-147.65,0-17.42,0-31,.05-40.14,0-4.58,0-8.08,0-10.44s0-3.55,0-3.55,0,1.2,0,3.55,0,5.86,0,10.44c0,9.18,0,22.72,0,40.14,0,34.87.06,85.32.1,147.65q0,23.38,0,48.93c0,2.13,0,4.26,0,6.41v3.23a22.49,22.49,0,0,1-.14,3.27,13.1,13.1,0,0,1-7.76,10.18,13.41,13.41,0,0,1-3.25.91,22.31,22.31,0,0,1-3.36.16H414.72l-117,0-129.34,0H51.68a23.23,23.23,0,0,1-4.47-.23,13.12,13.12,0,0,1-10.69-12.92c0-47.56,0-94,0-138.84q0-33.63,0-66V99.19a19.88,19.88,0,0,1,.26-3.92,14.23,14.23,0,0,1,1.33-3.7,13.39,13.39,0,0,1,5.55-5.41,12.69,12.69,0,0,1,3.7-1.23,20.82,20.82,0,0,1,3.85-.21H96.1l56.8,0,102,0,147.65.09,23.17,0H435a20.34,20.34,0,0,1,4,.26,12.83,12.83,0,0,1,3.44,1.22,12.8,12.8,0,0,1,6.42,7.91,9.81,9.81,0,0,1,.32,1.51,7.55,7.55,0,0,1,.12,1.11C449.35,97.51,449.35,97.82,449.35,97.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.62,217.69a11,11,0,1,1-11,11A11,11,0,0,1,428.62,217.69Z",
    style: {
      fill: "#bdbdbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.61,199.27V258a4.09,4.09,0,0,1-4.09,4.1h0a4.1,4.1,0,0,1-4.1-4.1v-58.7a4.1,4.1,0,0,1,4.1-4.1h0A4.09,4.09,0,0,1,58.61,199.27Z",
    style: {
      fill: "#bdbdbd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.24,
    y: 94.3,
    width: 344.52,
    height: 269.34,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.37 288.73 315.01 335.68 380.51 334.71 376.8 283.76 288.37 288.73",
    style: {
      fill: "#91add321"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.79 130.18 192.17 204.39 212.04 209.13 250.89 205.27 243.76 124.2 201.79 130.18",
    style: {
      fill: "#91add321"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.44 282.06 95.52 282.06 95.52 226.77 145.42 227.27 141.44 282.06",
    style: {
      fill: "#6683ab21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.48,283.76c0-1.57,8.09-56.49,8.09-56.49s31.66-8.67,31.78-7.43,6.3,62.46,6.3,62.46Z",
    style: {
      fill: "#6683ab21"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.8,143.1c.09,1.34,21.93,45.26,21.93,45.26l25.29-6.7V131.13l-26.08-.6Z",
    style: {
      fill: "#91add321"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.27,
    y: 234.74,
    width: 34.97,
    height: 16.5,
    style: {
      fill: "#91add321"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.4 256.71 220.18 258.49 218.39 291.93 258.61 288.73 255.4 256.71",
    style: {
      fill: "#91add321"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.48 194.7 391.59 126.82 410.67 126.82 410.76 193.35 396.48 194.7",
    style: {
      fill: "#91add321"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.34 115.7 326.29 200.29 368 196.55 360.72 124.4 327.7 115.7 318.34 115.7",
    style: {
      fill: "#91add321"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.7 130.83 66.48 129.92 66.54 125.92 123.44 126.78 130.01 94.33 133.94 95.12 126.7 130.83",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.23 196.17 66.05 130.73 66.96 130.32 95.8 194.98 147.9 181.17 148.15 182.14 95.23 196.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.52,
    y: 226.27,
    width: 78.91,
    height: 2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.01,
    y: 195.58,
    width: 1,
    height: 86.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.52,
    y: 281.62,
    width: 75.19,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.81 360.31 66.2 344.51 67.06 340.6 134.16 355.41 145.67 195.26 147.4 128.65 150.09 94.57 154.07 94.88 151.39 128.91 149.67 195.46 137.81 360.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.23 133.26 124.87 130.8 125.28 126.82 146.81 129 150.37 121.4 182.46 129.18 326.76 112.73 377.03 125.79 410.61 124.82 410.73 128.81 376.58 129.81 326.47 116.79 182.21 133.23 152.61 126.06 149.23 133.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317 286.87 313.03 286.35 324.27 200.27 315.63 115.78 315.63 94.3 319.63 94.3 319.63 115.68 328.3 200.32 317 286.87",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.74 298.71 139.5 294.72 375.37 280.38 407.47 215.02 411.06 216.78 377.94 284.23 376.78 284.3 139.74 298.71",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.84 291.14 242.76 124.29 241.94 94.76 243.94 94.7 244.76 124.18 259.83 290.96 257.84 291.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.18 362.57 208.74 291.35 208.74 210.79 189.11 205.91 197.63 129.44 196.84 94.34 200.84 94.25 201.64 129.62 201.63 129.75 193.47 202.87 212.74 207.67 212.74 290.86 230.07 361.62 226.18 362.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.42,
    y: 226.77,
    width: 65.32,
    height: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.98,
    y: 177.63,
    width: 1,
    height: 44.54,
    transform: "translate(-60.49 325.59) rotate(-78.37)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.63 260.38 195.11 256.95 195.11 227.27 196.11 227.27 196.11 256.15 210.85 259.4 210.63 260.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.4 362.52 177.68 334.53 137.77 334.53 137.77 330.53 180.62 330.53 190.22 361.33 186.4 362.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.72 336.19 287.94 288.97 288.81 288.48 315.3 335.18 410.54 333.76 410.56 334.76 314.72 336.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.58,
    y: 335.68,
    width: 1,
    height: 26.96,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.01 334.75 376.3 283.8 357.18 94.35 358.18 94.25 377.3 283.71 381.01 334.67 380.01 334.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.42,
    y: 200.79,
    width: 200.65,
    height: 1,
    transform: "translate(-14.95 25.21) rotate(-4.54)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.56,
    y: 128.41,
    width: 2,
    height: 66.43,
    transform: "translate(-12.88 35.94) rotate(-5.13)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.22,
    y: 169.26,
    width: 30.19,
    height: 1,
    transform: "translate(-29.64 96.32) rotate(-13.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.97 168.97 376.78 139.55 362.15 138 362.25 137.01 377.63 138.64 382.95 168.79 381.97 168.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.4,
    y: 120.72,
    width: 2,
    height: 81.32,
    transform: "translate(-12.74 24.97) rotate(-4.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.01,
    y: 169,
    width: 36.29,
    height: 1,
    transform: "translate(-29.31 69.3) rotate(-12.41)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.97,
    y: 348.8,
    width: 28.46,
    height: 2,
    transform: "translate(-73.78 615.68) rotate(-82.65)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.4 228.97 145.42 291.05 207.47 288.03 207.47 263.67 191.22 260.08 191.22 231.64 149.4 228.97",
    style: {
      fill: "#91add321"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.31,244.09a14.1,14.1,0,1,0-26.26,7.13h0l0,.05c.54.91,1.21,1.56,1.9,2.52l8.18,10.84a2.55,2.55,0,0,0,4.07,0l8-10.66a31.26,31.26,0,0,0,2.05-2.71l0,0h0A14,14,0,0,0,132.31,244.09Zm-14.1,6.14a6.21,6.21,0,1,1,6.2-6.2A6.21,6.21,0,0,1,118.21,250.23Z",
    style: {
      fill: "#0E2977"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,194.48a14.1,14.1,0,1,0-26.25,7.12h0l0,.06c.54.91,1.22,1.56,1.91,2.52L248.86,215a2.55,2.55,0,0,0,4.07,0L261,204.35a29.77,29.77,0,0,0,2-2.71l0,0h0A14,14,0,0,0,265,194.48Zm-14.1,6.14a6.21,6.21,0,1,1,6.21-6.21A6.21,6.21,0,0,1,250.89,200.62Z",
    style: {
      fill: "#0E2977"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.46,316.62a9.67,9.67,0,1,0-18,4.88h0l0,0c.37.62.84,1.07,1.31,1.72l5.61,7.44a1.75,1.75,0,0,0,2.78,0l5.52-7.31a22.08,22.08,0,0,0,1.41-1.86l0,0h0A9.62,9.62,0,0,0,206.46,316.62Zm-9.67,4.21a4.26,4.26,0,1,1,4.25-4.26A4.25,4.25,0,0,1,196.79,320.83Z",
    style: {
      fill: "#0E2977"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.87,141.1a9.67,9.67,0,0,0-19.18-1.71,9.57,9.57,0,0,0,1.18,6.59h0l0,0c.37.62.84,1.07,1.31,1.73l5.61,7.43a1.75,1.75,0,0,0,2.78,0l5.52-7.31a22.08,22.08,0,0,0,1.41-1.86l0,0h0A9.62,9.62,0,0,0,381.87,141.1Zm-9.67,4.21a4.26,4.26,0,1,1,4.25-4.25A4.25,4.25,0,0,1,372.2,145.31Z",
    style: {
      fill: "#0E2977"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,145.7a17.14,17.14,0,1,0-31.92,8.66h0l.05.06c.65,1.11,1.48,1.9,2.31,3.06l9.95,13.19a3.1,3.1,0,0,0,4.94,0l9.79-13a36.47,36.47,0,0,0,2.49-3.3l0,0h0A17.11,17.11,0,0,0,176,145.7Zm-17.15,7.46a7.55,7.55,0,1,1,7.55-7.54A7.55,7.55,0,0,1,158.85,153.16Z",
    style: {
      fill: "#0E2977"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84,419.57S61.48,393.72,53,367.86,48.56,345,48.56,345,60,370.09,68.69,382.22s24.16,29.94,24.16,29.94Z",
    style: {
      fill: "#3cbba3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.43,349a1.31,1.31,0,0,0-2.44.83c1.37,9.09,4.33,30.4,4.21,44.22-.15,18,0,24.9,0,24.9h9.35s-1.66-37.12-3.77-48.44C94.31,362.58,91.16,353.77,88.43,349Z",
    style: {
      fill: "#3cbba3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.52,415.93a98.85,98.85,0,0,0,7.7-27.91c.77-6.61-.6-15.55-2.65-27.47a74.08,74.08,0,0,1-1.18-13.21,2.23,2.23,0,0,1,4.19-1c1.13,2,4.39,8.89,5.22,13.21,2.27,11.77,4.83,17.65,2.87,28.82s-9.2,28.37-9.2,28.37Z",
    style: {
      fill: "#3cbba3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,416.69s24.66-53,26.37-60.87,7.52-26,8.21-25,1.71,10.6-2.74,21.54-23.42,65.9-23.42,65.9H102",
    style: {
      fill: "#3cbba3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.82,414.32a5.36,5.36,0,0,1-.69-.48c-.44-.33-1.1-.8-1.91-1.46-1.64-1.29-3.94-3.25-6.63-5.85a111.27,111.27,0,0,1-17.89-23A150.83,150.83,0,0,1,51.48,357.1c-1.24-3.52-2.14-6.4-2.73-8.4-.3-1-.51-1.78-.66-2.31a6.32,6.32,0,0,1-.19-.82,5.23,5.23,0,0,1,.3.79q.27.84.75,2.28c.64,2,1.6,4.84,2.88,8.34a160.58,160.58,0,0,0,12.32,26.31,116.47,116.47,0,0,0,17.7,23c2.64,2.62,4.9,4.62,6.5,6,.79.69,1.43,1.18,1.85,1.54A4.12,4.12,0,0,1,90.82,414.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.52,388.89a10.3,10.3,0,0,1-.22-1.56c-.12-1.1-.27-2.53-.45-4.25-.39-3.58-1-8.53-1.88-14s-1.84-10.32-2.6-13.85c-.36-1.69-.66-3.1-.9-4.18a8.15,8.15,0,0,1-.27-1.55,10.46,10.46,0,0,1,.47,1.5c.28,1,.65,2.39,1.07,4.15.85,3.51,1.88,8.4,2.75,13.84s1.43,10.42,1.73,14c.15,1.8.24,3.26.29,4.27A8.63,8.63,0,0,1,93.52,388.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3,345.87a3.65,3.65,0,0,1,.29.68l.74,2c.33.85.7,1.9,1.06,3.15s.84,2.65,1.2,4.25c.19.79.4,1.62.61,2.49s.35,1.79.54,2.73c.4,1.88.65,3.92,1,6.06a98.62,98.62,0,0,1,.59,14.05,98.37,98.37,0,0,1-1.59,14c-.45,2.12-.85,4.14-1.38,6-.26.92-.47,1.83-.74,2.68s-.54,1.66-.79,2.44c-.47,1.57-1,2.93-1.5,4.15s-.89,2.24-1.28,3.07l-.88,1.91a3.1,3.1,0,0,1-.34.65,4.79,4.79,0,0,1,.24-.69l.79-1.95c.36-.84.78-1.87,1.2-3.1s1-2.59,1.42-4.15l.75-2.45c.26-.85.46-1.75.7-2.67.52-1.85.89-3.86,1.33-6a103.71,103.71,0,0,0,1.55-13.9,104,104,0,0,0-.55-14c-.28-2.13-.52-4.17-.9-6-.18-.94-.31-1.86-.51-2.72l-.57-2.49c-.34-1.6-.78-3-1.12-4.25s-.68-2.31-1-3.18-.49-1.49-.65-2A3.42,3.42,0,0,1,99.3,345.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.25,331.92a2.18,2.18,0,0,1,0,.24c0,.19-.07.41-.11.69-.11.6-.25,1.5-.49,2.64-.48,2.28-1.27,5.56-2.5,9.54s-2.92,8.65-4.92,13.78-4.3,10.72-6.49,16.67-3.93,11.75-5.54,17-3.11,10-4.58,13.9a88.43,88.43,0,0,1-3.89,9.06c-.5,1.05-1,1.83-1.25,2.37l-.35.61a1.23,1.23,0,0,1-.13.2s0-.08.09-.23l.29-.63c.27-.55.69-1.35,1.17-2.41,1-2.1,2.33-5.19,3.73-9.1s2.88-8.64,4.45-13.91,3.29-11.09,5.52-17.05,4.52-11.55,6.53-16.67,3.74-9.76,5-13.71,2.12-7.22,2.66-9.48c.27-1.13.44-2,.58-2.61.07-.27.12-.5.16-.68A.74.74,0,0,1,136.25,331.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.19,320.21a2.13,2.13,0,0,0-3.5,2.17,60.39,60.39,0,0,0,3.1,8c3.39,7.2,13.35,33.06,18,47.26S89,418.3,89,418.3L99,416.69s-9.11-43.53-18-59.21C73.83,344.88,66.68,326.66,60.19,320.21Z",
    style: {
      fill: "#3cbba3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.53,386.49a7.23,7.23,0,0,1,.51,1.2c.3.78.7,1.92,1.15,3.34.92,2.84,2,6.81,3.17,11.21s2.07,8.42,2.72,11.33l.75,3.45A6.53,6.53,0,0,1,89,418.3a5.71,5.71,0,0,1-.41-1.23c-.24-.91-.55-2.05-.91-3.41-.76-3-1.76-6.93-2.87-11.29s-2.19-8.37-3-11.23l-1-3.39A5.65,5.65,0,0,1,80.53,386.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,417.5a1,1,0,0,1-.06-.27c0-.21-.07-.47-.11-.78-.11-.69-.2-1.72-.41-3-.36-2.62-1-6.38-2.09-11a156.06,156.06,0,0,0-4.66-15.91c-2-5.9-4.6-12.27-7.5-18.87-5.86-13.18-11.71-24.86-15.56-33.51-1.94-4.31-3.45-7.83-4.44-10.28-.5-1.22-.86-2.18-1.12-2.83l-.27-.74a1.09,1.09,0,0,1-.08-.26s0,.07.13.24l.32.72,1.21,2.79C60.45,326.23,62,329.72,64,334c3.93,8.6,9.83,20.25,15.7,33.45,2.91,6.61,5.46,13,7.48,18.92a149.47,149.47,0,0,1,4.57,16,112,112,0,0,1,1.92,11c.18,1.31.24,2.34.31,3,0,.33,0,.59.07.79A1,1,0,0,1,94,417.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,416.69a12,12,0,0,1-.33-1.68c-.2-1.16-.46-2.71-.78-4.57-.68-3.86-1.73-9.17-3.24-15s-3.17-10.93-4.46-14.63l-1.56-4.38a11.33,11.33,0,0,1-.53-1.62,9.91,9.91,0,0,1,.72,1.55c.43,1,1,2.48,1.72,4.32a144,144,0,0,1,4.62,14.63,151.51,151.51,0,0,1,3.1,15c.28,1.94.5,3.51.61,4.61A9.7,9.7,0,0,1,99,416.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.56,
    y: 415.26,
    width: 38.86,
    height: 47.35,
    style: {
      fill: "#0E2977"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80.56,
    y: 415.26,
    width: 38.86,
    height: 47.35
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 72.55,
    y: 415.26,
    width: 34.48,
    height: 47.35,
    style: {
      fill: "#0E2977"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.29,268a13.38,13.38,0,0,0-13.38-13.38H201.45a13.38,13.38,0,0,0,0,26.75h48.69c4.57,4.41,12.38,10.36,12.38,10.36V280.88l21.37.43C291.2,281.09,296.29,275,296.29,268Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.29,268s0,.24,0,.73a12.59,12.59,0,0,1-.24,2.14,14.1,14.1,0,0,1-1.08,3.33,13.56,13.56,0,0,1-2.82,3.87,12.37,12.37,0,0,1-5.21,2.92,16.58,16.58,0,0,1-1.65.35,16.77,16.77,0,0,1-1.75.11l-3.69-.06-17.32-.31.19-.19c0,3.42,0,7.05,0,10.83v.43l-.33-.26c-4-3.09-8.27-6.45-12.42-10.36l.16.07-29.5,0H204.58c-1.38,0-2.73.05-4.15-.05a13.71,13.71,0,0,1-12-9.56,14.25,14.25,0,0,1-.58-3.36,14.69,14.69,0,0,1,.24-3.38,14.14,14.14,0,0,1,1.09-3.19,13.56,13.56,0,0,1,10.23-7.55,19.36,19.36,0,0,1,3.21-.17H224l41.59.06,16,0a20,20,0,0,1,3.41.18,13.9,13.9,0,0,1,3.06.85,13.52,13.52,0,0,1,4.55,3.12,12.81,12.81,0,0,1,2.48,3.64,15.54,15.54,0,0,1,.65,1.65c.14.52.26,1,.35,1.42a12.29,12.29,0,0,1,.21,2c0,.45,0,.68,0,.68s0-.23-.06-.68a15.19,15.19,0,0,0-.26-2c-.1-.42-.23-.89-.38-1.4a12.87,12.87,0,0,0-.66-1.62,12.54,12.54,0,0,0-2.49-3.57,13.38,13.38,0,0,0-4.49-3,13.58,13.58,0,0,0-3-.81,19.43,19.43,0,0,0-3.37-.16l-16,0-41.59,0H202.62a18.09,18.09,0,0,0-3.13.16,13.23,13.23,0,0,0-10.89,10.34,13.72,13.72,0,0,0,.32,6.49,13.82,13.82,0,0,0,1.38,3,13,13,0,0,0,10.17,6.19c1.34.1,2.75,0,4.11.05h16.06l29.5,0h.09l.07.06c4.11,3.89,8.37,7.26,12.35,10.36l-.34.16c0-3.78,0-7.41,0-10.83v-.19h.2l17.31.39c2.54,0,4.94.31,7-.35A12.25,12.25,0,0,0,292,277.9a13.31,13.31,0,0,0,2.81-3.78,14.35,14.35,0,0,0,1.42-5.4C296.26,268.23,296.29,268,296.29,268Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.71,272.17a4.68,4.68,0,0,1-.64,0,4.91,4.91,0,1,1,5.52-4.24h0A4.93,4.93,0,0,1,278.71,272.17Zm0-8.83a3.9,3.9,0,0,0-3.87,3.41,3.93,3.93,0,0,0,3.37,4.39,3.92,3.92,0,0,0,4.39-3.38h0a3.91,3.91,0,0,0-3.37-4.39A4.53,4.53,0,0,0,278.7,263.34Zm4.39,4.49h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.39,273.32a.51.51,0,0,1-.32-.12l-3.21-2.68a.5.5,0,0,1,.64-.77l3.21,2.68a.51.51,0,0,1,.07.71A.5.5,0,0,1,285.39,273.32Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.9b9ade4214cdbd70979647db6725e6a4.svg";
export { ForwardRef as ReactComponent };